import {
  useListOrganizations,
  useListPayors,
  useListSitesByOrganization,
} from 'api/resource';
import { useIsAdmin } from 'hooks/useIsAdmin';
import { useCurrentUserStore } from 'store/UserStore';

export const useUserSiteManagementData = () => {
  const { organizationID } = useCurrentUserStore();

  const isAdmin = useIsAdmin();

  const sitesResult = useListSitesByOrganization({ orgID: organizationID });

  const payorsResult = useListPayors();

  const organizationResult = useListOrganizations({ isAdmin, organizationID });

  const isLoading =
    sitesResult.isLoading ||
    payorsResult.isLoading ||
    organizationResult.isLoading;
  const isFetching =
    sitesResult.isFetching ||
    payorsResult.isFetching ||
    organizationResult.isFetching;
  const isError =
    sitesResult.isError || payorsResult.isError || organizationResult.isError;
  const errorMessage =
    sitesResult.error?.message ||
    payorsResult.error?.message ||
    organizationResult.error?.message;

  return {
    sites: sitesResult.data || [],
    payors: payorsResult.data || [],
    organizations: organizationResult.data || [],
    isLoading: isLoading,
    isFetching: isFetching,
    isError: isError,
    errorMessage: errorMessage,
  };
};
